/* eslint one-var: "off" */
define([
	'components/utilities/utilities',
	'libs/nanoajax',
	'choices.js'
], function (utils, nanoajax, Choices) {
	'use strict';

	/**
	 * EpiserverForm
	 * A plugin that handles Episerver forms in an accessible way.
	 * @version 1.1.0
	 * @exports episerverForm
	 */
	return function () {
		var episerverForm = {

			/** Placeholder for form node. */
			formNode: null,

			/** Boolean to indicate if there are any ajax-request in progress. */
			requestInProgress: false,

			/**
			 * Constructor function.
			 * @private
			 */
			_constructor: function () {
				return this;
			},


			/**
			 * The initialization function for this module.
			 * @param {Object} formNode - A DOM node.
			 * @public
			 */
			init: function (formNode) {
				console.log("HERE");
				this.formNode = formNode;
				this.formMessageNode = formNode.querySelector('.form__message');
				this.fieldHolderNode = formNode.querySelector('.form__fields-holder');

				this._initialFocus();
				this._initMultipleSelects();
				this._initEvents();
			},


			/**
			 * Function that sets focus to the form__status container on load.
			 * @private
			 */
			_initialFocus: function () {
				var statusNode = this.formNode.querySelector('.form__status');

				if (statusNode) {
					statusNode.focus();
				}
			},


			/**
			 * Initiates multiple selects with Choices.js
			 * @private
			 */
			_initMultipleSelects: function () {
				var multipleSelects = this.formNode.querySelectorAll('select[multiple]'),
					that = this;

				utils.forEach(multipleSelects, function (select) {
					new Choices(select, {
						removeItemButton: true,
						placeholder: true,
						placeholderValue: select.getAttribute('data-placeholder') || '',
						itemSelectText: 'Klicka för att välja',
						noChoicesText: 'Det finns inga alternativ att välja på.',
						noResultsText: 'Inga resultat.',
						loadingText: 'Laddar...'
					});

					select.addEventListener('removeItem', function () {
						that._cleanupFieldValidationError(select);
						that._checkIfFieldHasValidationErrors(select);
					}, false);

					select.addEventListener('addItem', function () {
						that._cleanupFieldValidationError(select);
						that._checkIfFieldHasValidationErrors(select);
					}, false);
				});
			},


			/**
			 * Function that submits the form through ajax.
			 * @private
			 */
			_submit: function (stepData, stepId) {
				var that = this,
					method = this.formNode.getAttribute('method') ? this.formNode.getAttribute('method') : 'POST',
					url = this.formNode.getAttribute('action'),
					formData = stepData || new FormData(this.formNode),
					data = {};

				if (this.requestInProgress === false) {
					this.requestInProgress = true;

					nanoajax.ajax({
						method: method,
						headers: {
							'X-Requested-With': 'XMLHttpRequest'
						},
						url: url,
						body: formData
					},
					function (code, responseText) {
						if (code === 200) {
							try {
								data = JSON.parse(responseText);
							} catch (e) {}

							if (data.RedirectUrl) {
								window.location.href = data.RedirectUrl;
								return;
							}

							that._cleanupValidationErrors();
							that._hideLoadingIndicator();

							if (!data.IsSuccess) {
								that._handleFormError(data);
							}

							// Update hidden fields if needed.
							if (stepId && data.Data && data.Data.CurrentStepIndex) {
								for (var key in data.Data) {
									if (data.Data.hasOwnProperty(key)) {
										var field = that.formNode.querySelector('[name="__Form' + key + '"]');
										if (field) {
											field.value = data.Data[key];
										}
									}
								}
							}
							if (stepId && data.IsSuccess) {
								that._showStep(stepId);
							}
							else if (that.formMessageNode && data.Message && data.Message !== '') {
								that._displayMessage(data);
							}
						} else {
							that._hideLoadingIndicator();
							alert(that.formNode.getAttribute('data-server-error-message') || 'Ett fel inträffade, vänligen försök igen senare.');
						}
						that.requestInProgress = false;
					});
				}
			},


			/**
			 * Removes validation invalid classes and validation error labels.
			 * @private
			 */
			_cleanupValidationErrors: function () {
				var invalidFields = this.formNode.querySelectorAll('.form__field--invalid'),
					invalidLabels = this.formNode.querySelectorAll('.form__label--invalid');

				utils.forEach(invalidFields, function (field) {
					utils.removeClass(field, 'form__field--invalid');
				});

				utils.forEach(invalidLabels, function (label) {
					utils.remove(label);
				});
			},


			/**
			 * Cleans up validation error for a specific field
			 * @param {Node} field - The field node
			 * @private
			 */
			_cleanupFieldValidationError: function (field) {
				var invalidLabel = this._getFieldLabelNode(field).querySelector('.form__label--invalid'),
					formField = field.tagName === 'SELECT' && field.getAttribute('multiple') ?
						field.parentNode.querySelector('input') : field;

				utils.removeClass(formField, 'form__field--invalid');

				if (invalidLabel) {
					utils.remove(invalidLabel);
				}
			},


			/**
			 * Returns the label node for the provided field
			 * @param {Node} field - The field node
			 * @private
			 */
			_getFieldLabelNode: function (field) {
				if (utils.hasClass(field, 'choices__input')) {
					return field.parentNode.parentNode.parentNode.querySelector('label');
				} else if (field.tagName === 'FIELDSET') {
					return field.querySelector('legend');
				} else {
					return field.parentNode.querySelector('label');
				}
			},


			/**
			 * Handles serverside validation errors.
			 * @param {Object} data - Form response data.
			 * @private
			 */
			_handleFormError: function (data) {
				var that = this;

				if (data.AdditionalParams && data.AdditionalParams.__FormField) {
					var displayMessageHTML = '<ul>';

					utils.forEach(data.AdditionalParams.__FormField, function (field, index) {
						var fieldNode = document.getElementById(field.InvalidElement),
							fieldType;

						displayMessageHTML += '<li><strong>' + field.InvalidElementLabel + '</strong>' +
							'<span class="form__label--invalid">' + field.ValidationMessage + '</span></li>';

						if (fieldNode) {
							fieldType = fieldNode.getAttribute('type');
							utils.addClass(fieldNode, 'form__field--invalid');

							if (field.ValidationMessage && field.ValidationMessage !== '') {
								var validationMessageNode = document.createElement('span'),
									validationMessage = document.createTextNode(field.ValidationMessage);

								validationMessageNode.appendChild(validationMessage);
								utils.addClass(validationMessageNode, 'form__label--invalid');

								if (fieldNode.tagName === 'FIELDSET') {
									validationMessageNode.setAttribute('tabindex', -1);

									var fieldNodeLegend = fieldNode.querySelector('legend');
									if (fieldNodeLegend) {
										fieldNodeLegend.appendChild(validationMessageNode);
									}

									if (index === 0) {
										validationMessageNode.focus();
									}
								} else {
									var fieldNodeLabel = that.formNode.querySelector('[for="' + field.InvalidElement + '"]');

									if (fieldType === 'checkbox' || fieldType === 'radio') {
										if (fieldNodeLabel) {
											fieldNodeLabel.appendChild(validationMessageNode);
										}
									} else {
										fieldNodeLabel.appendChild(validationMessageNode);
									}
								}
							}

							if (index === 0) {
								if (fieldNode.tagName !== 'FIELDSET') {
									fieldNode.focus();
								}

								// Set cursor at the end of the fields value.
								if (fieldNode.selectionStart || fieldNode.selectionStart == '0') {
									var elementValueLength = fieldNode.value.length;
									fieldNode.selectionStart = elementValueLength;
									fieldNode.selectionEnd = elementValueLength;
									fieldNode.focus();
								}
							}
						}
					});

					displayMessageHTML += '</ul>';

					this._displayValidationErrorSummary(data.AdditionalParams.__FormField.length, displayMessageHTML);
				}
			},


			/**
			 * Displays a validation error summary above the form.
			 * @param {Number} nrOfErrors - Number of fields that has validation errors.
			 * @param {String} fieldsListHTML - String of HTML containing a ul-list with invalid field labels.
			 * @private
			 */
			_displayValidationErrorSummary: function (nrOfErrors, fieldsListHTML) {
				this._cleanupOldStatusMessages();

				var errorMessage = this.formNode.getAttribute('data-validation-error-message') || 'Formuläret innehåller {0} fel:',
					headlineNode = document.createElement('h2'),
					responseMessageNode = this._createMessageNode();

				headlineNode.innerHTML = errorMessage.replace('{0}', nrOfErrors);
				responseMessageNode.appendChild(headlineNode);
				responseMessageNode.innerHTML += fieldsListHTML;

				this.formMessageNode.appendChild(responseMessageNode);
				responseMessageNode.focus();
			},


			/**
			 * Cleans up old status messages
			 * @private
			 */
			_cleanupOldStatusMessages: function () {
				var statuses = this.formMessageNode.querySelectorAll('.form__status');

				utils.forEach(statuses, function (status) {
					utils.remove(status);
				});
			},


			/**
			 * Creates a div message node and sets correct classes.
			 * @param {Object} data - Form response data.
			 * @private
			 */
			_createMessageNode: function (data) {
				var responseMessageNode = document.createElement('div');

				responseMessageNode.setAttribute('tabindex', '-1');
				utils.addClass(responseMessageNode, 'form__status');
				utils.addClass(responseMessageNode, 'form__rte');

				if (data && data.IsSuccess) {
					utils.addClass(responseMessageNode, 'form__status--success');
				} else {
					utils.addClass(responseMessageNode, 'form__status--error');
				}

				return responseMessageNode;
			},


			/**
			 * Displays a message above the form.
			 * @param {Object} data - Form response data.
			 * @private
			 */
			_displayMessage: function (data) {
				var responseMessageNode = this._createMessageNode(data);

				responseMessageNode.innerHTML = data.Message;

				// Remove all content in formMessageNode
				while (this.formMessageNode.firstChild) {
					this.formMessageNode.removeChild(this.formMessageNode.firstChild);
				}

				this.formMessageNode.appendChild(responseMessageNode);
				responseMessageNode.focus();
				utils.addClass(this.fieldHolderNode, 'form__fields-holder--hidden');
			},


			/**
			 * Submits a step in a multi step form.
			 * @param {String} stepId - The id of the step section node.
			 * @private
			 */
			_submitStep: function (stepId) {
				var currentStep = this.formNode.querySelector('.form__section[aria-hidden="false"]'),
					currentStepFields = [],
					formData = new FormData(),
					that = this;

				formData = this._getHiddenFieldValues(formData);

				if (currentStep) {
					currentStepFields = currentStep.querySelectorAll('input, select, textarea');

					utils.forEach(currentStepFields, function (field) {
						if (!utils.hasClass(field, 'choices__input--cloned')) {
							formData = that._getFieldValue(field, formData);
						}
					});

					this._submit(formData, stepId);
				}
			},


			/**
			 * Extracts values from hidden fields and appends to FormData object
			 * @param {FormData} formData - Current form data
			 * @returns {FormData}
			 * @private
			 */
			_getHiddenFieldValues: function (formData) {
				var hiddenFieldHolder = this.formNode.querySelector('.form__hidden-fields'),
					hiddenFields = [];

				if (hiddenFieldHolder) {
					hiddenFields = hiddenFieldHolder.querySelectorAll('input, select');

					utils.forEach(hiddenFields, function (field) {
						formData.append(field.getAttribute('name'), field.value);
					});
				}

				return formData;
			},


			/**
			 * Extracts value from the given field and appends to FormData object
			 * @param {Node} field - The current field node
			 * @param {FormData} formData - Current form data
			 * @returns {FormData}
			 * @private
			 */
			_getFieldValue: function (field, formData) {
				var type = field.getAttribute('type');

				// Selects
				if (field.options) {
					for (var i = 0; i < field.options.length; i++) {
						if (field.options[i].selected) {
							formData.append(field.getAttribute('name'), field.options[i].value);
						}
					}
				}
				// Checkbox and radio
				else if (type === 'checkbox' || type === 'radio') {
					if (field.checked) {
						formData.append(field.getAttribute('name'), field.value);
					}
				}
				// Files
				else if (type === 'file') {
					for (var j = 0; j < field.files.length; j++) {
						formData.append(field.getAttribute('name'), field.files[j]);
					}
				// All other fields
				} else {
					formData.append(field.getAttribute('name'), field.value);
				}

				return formData;
			},


			/**
			 * Validates a step in a multi step form.
			 * @private
			 */
			_validateStep: function () {
				var currentStep = this.formNode.querySelector('.form__section[aria-hidden="false"]'),
					currentStepFields = [];

				if (currentStep) {
					currentStepFields = currentStep.querySelectorAll('input, select, fieldset');
				}

				return this._checkValidity(currentStepFields);
			},


			/**
			 * Shows a step in a multi step form.
			 * @param {String} stepId - The id of the step section node.
			 * @private
			 */
			_showStep: function (stepId) {
				var stepButtons = this.formNode.querySelectorAll('[aria-controls]'),
					steps = this.formNode.querySelectorAll('.form__section'),
					nextStep = document.getElementById(stepId),
					nextStepHeadline = nextStep.querySelector('.form__section__headline'),
					nextStepButton = this.formNode.querySelector('[aria-controls=' + stepId + ']');

				utils.forEach(stepButtons, function (btn) {
					btn.setAttribute('aria-expanded', false);
				});

				utils.forEach(steps, function (step) {
					step.setAttribute('aria-hidden', true);
					utils.addClass(step, 'form__section--hidden');
				});

				nextStep.setAttribute('aria-hidden', false);
				utils.removeClass(nextStep, 'form__section--hidden');
				nextStepButton.setAttribute('aria-expanded', true);

				if (nextStepHeadline) {
					nextStepHeadline.focus();
				}
			},


			/**
			 * Displays a spinner and a message in button.
			 * @param {Object} btn - A button node.
			 * @private
			 */
			_displayLoadingIndicator: function (btn) {
				var loadingMessage = btn.getAttribute('data-loading-message') || 'Laddar...';
				btn.setAttribute('data-innerhtml', btn.innerHTML);
				utils.addClass(btn, 'form__button--loading');
				btn.innerHTML = '<span class="form__loader" aria-hidden="true"></span> ' + loadingMessage;
			},


			/**
			 * Hides the spinner and message in buttons and restores their innerHTML.
			 * @private
			 */
			_hideLoadingIndicator: function () {
				var loadingButtons = this.formNode.querySelectorAll('.form__button--loading');

				utils.forEach(loadingButtons, function (btn) {
					var oldInnerHtml = btn.getAttribute('data-innerhtml');
					btn.innerHTML = oldInnerHtml;
				});
			},


			/**
			 * Returns the current steps next button.
			 * @private
			 */
			_getCurrentNextButton: function () {
				var currentNextButton = null,
					nextButtons = this.formNode.querySelectorAll('.form__button--next');

				utils.forEach(nextButtons, function (btn) {
					if (btn.offsetParent !== null) {
						currentNextButton = btn;
					}
				});

				return currentNextButton;
			},


			/**
			 * Checks if all fields with requirements (required, pattern) are valid before the form is submitted
			 * @param {Array} fields - If we're validating a multistep form, the function is provided with the fields array
			 * @private
			 */
			_checkValidity: function (fields) {
				var allFields = fields || this.formNode.querySelectorAll('input, select, fieldset, textarea'),
					hasValidationErrors = false,
					that = this;

				this._cleanupValidationErrors();

				var displayMessageHTML = '<ul>',
					nrOfInvalidFields = 0;

				utils.forEach(allFields, function (field) {
					if (that._checkIfFieldHasValidationErrors(field)) {
						hasValidationErrors = true;

						displayMessageHTML += '<li><strong>' + that._getFieldLabelNode(field).innerHTML + '</strong></li>';
						nrOfInvalidFields += 1;
					}
				});

				displayMessageHTML += '</ul>';

				if (hasValidationErrors) {
					this._displayValidationErrorSummary(nrOfInvalidFields, displayMessageHTML);
				}

				return hasValidationErrors;
			},


			/**
			 * Checks if a field has validation errors, if so, renders a validation error message
			 * @param {Node} field - The field node to validate
			 * @private
			 */
			_checkIfFieldHasValidationErrors: function (field) {
				var hasValidationErrors = false;

				if (field.type === 'url' && !field.checkValidity()) {
					hasValidationErrors = true;
					this._showValidationErrorMessage(field, field.getAttribute('data-validation-message') || 'Tillhandahåll en giltig url.');
				}

				if ((field.required && field.value === '') ||
					(field.getAttribute('data-required') && !this._fieldsetHasOneCheckedInput(field)))
				{
					hasValidationErrors = true;
					this._showValidationErrorMessage(field, field.getAttribute('data-validation-message') || 'Du måste fylla i det här fältet.');
				}

				if (field.pattern && !field.value.match(field.pattern) && field.value !== '') {
					hasValidationErrors = true;
					this._showValidationErrorMessage(field, field.getAttribute('data-pattern-message') || 'Vänligen matcha det förväntade formatet.');
				}

				return hasValidationErrors;
			},


			/**
			 * Writes out a validation error message in field label tag and sets field as invalid.
			 * @param {Node} field - The input field node
			 * @param {String} message - The validation message to display
			 * @private
			 */
			_showValidationErrorMessage: function (field, message) {
				var fieldLabel = this._getFieldLabelNode(field),
					validationMessage = null,
					validationMessageNode = null;

				if (field.tagName === 'SELECT' && field.getAttribute('multiple')) {
					utils.addClass(field.parentNode.querySelector('input'), 'form__field--invalid');
				} else {
					utils.addClass(field, 'form__field--invalid');
				}

				validationMessage = document.createTextNode(message);
				validationMessageNode = document.createElement('span');

				validationMessageNode.appendChild(validationMessage);
				utils.addClass(validationMessageNode, 'form__label--invalid');

				fieldLabel.appendChild(validationMessageNode);
			},


			/**
			 * Checks if any input (radio/checkbox) within a required fieldset group has been checked
			 * @param {Node} fieldset - The fieldset node
			 * @private
			 */
			_fieldsetHasOneCheckedInput: function (fieldset) {
				var allInputs = fieldset.querySelectorAll('input'),
					hasOneValidInput = false;

				utils.forEach(allInputs, function (field) {
					if (field.checked) {
						hasOneValidInput = true;
					}
				});

				return hasOneValidInput;
			},


			/**
			 * Initiates events.
			 * @private
			 */
			_initEvents: function () {
				var that = this,
					multistepButtons = this.formNode.querySelectorAll('[aria-controls]'),
					allFields = this.formNode.querySelectorAll('input, fieldset, select, textarea');

				// Field validation on blur
				utils.forEach(allFields, function (field) {
					field.addEventListener('focusout', function () {
						var fieldIsPartOfAFieldset = field.parentNode.parentNode.tagName === 'FIELDSET';

						if (fieldIsPartOfAFieldset) {
							return;
						} else if (utils.hasClass(field, 'choices__input')) {
							field = field.parentNode.querySelector('select');
						}

						that._cleanupFieldValidationError(field);
						that._checkIfFieldHasValidationErrors(field);
					});
				});

				// Form submit
				utils.addEventListener(this.formNode, 'submit', function (event) {
					if (that._checkValidity()) {
						event.preventDefault();
						return;
					}

					// If the user submits with Enter press we need to handle multistep forms.
					var currentNextButton = that._getCurrentNextButton();
					if (currentNextButton) {
						that._submitStep(currentNextButton.getAttribute('aria-controls'));
						event.preventDefault();
						return false;
					}

					if (typeof(FormData) !== 'undefined') {
						if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }

						var submitBtn = that.formNode.querySelector('[type="submit"]');
						if (submitBtn) {
							that._displayLoadingIndicator(submitBtn);
						}
						that._submit();
					}
				});

				// Multistep forms
				utils.forEach(multistepButtons, function (btn) {
					utils.addEventListener(btn, 'click', function () {
						if (btn.getAttribute('data-epiform-previous')) {
							var currentStepIndexField = that.formNode.querySelector('[name="__FormCurrentStepIndex"]');
							if (currentStepIndexField) {
								currentStepIndexField.value = parseInt(currentStepIndexField.value, 10) - 1;
							}
							that._showStep(btn.getAttribute('aria-controls'));
							return false;
						}
						if (typeof(FormData) !== 'undefined') {
							that._cleanupOldStatusMessages();
							if (utils.hasClass(btn, 'form__button--prev') || !that._validateStep()) {
								that._displayLoadingIndicator(btn);
								that._submitStep(btn.getAttribute('aria-controls'));
							}
						} else {
							that.formNode.submit();
						}
					});
				});
			}
		};

		return episerverForm._constructor();
	};
});



//////////////////
// WEBPACK FOOTER
// ./components/episerverForm/episerverForm.js
// module id = 57
// module chunks = 11